/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilegroupplaces2Inputs */

const en_profilegroupplaces2 = /** @type {(inputs: Profilegroupplaces2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Places`)
};

const de_profilegroupplaces2 = /** @type {(inputs: Profilegroupplaces2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orte`)
};

/**
* | output |
* | --- |
* | "Places" |
*
* @param {Profilegroupplaces2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilegroupplaces2 = /** @type {((inputs?: Profilegroupplaces2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilegroupplaces2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilegroupplaces2(inputs)
	return de_profilegroupplaces2(inputs)
});
export { profilegroupplaces2 as "profileGroupPlaces" }